import React from 'react';
import {render} from 'react-dom';

import injectTapEventPlugin from 'react-tap-event-plugin';
import {lightBlue500} from 'material-ui/styles/colors'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

import {Router, Route} from 'react-router'
import history from './router/history'

import Start from './containers/Start'
import Welcome from './containers/Welcome'
import Login from './containers/Login'
import Portal from './containers/Portal'
import Register from './containers/Register'

injectTapEventPlugin();

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: lightBlue500

    }
});

render(
    <MuiThemeProvider muiTheme={muiTheme}>
        <Router history={history}>
            <Route path="/" component={Start}/>
            <Route path="/welcome" component={Welcome}/>
            <Route path="/login" component={Login}/>
            <Route path="/portal" component={Portal}/>
            <Route path="/register" component={Register}/>
        </Router>
    </MuiThemeProvider>,
    document.getElementById("app")
);



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/